import InfoElement from './InfoElement'

export default InfoElement
